import Typography, {
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import React, {useEffect, useState} from "react"

import styles from "./ThankYou.module.scss"

interface ThankYouProps {
	name: string
	customText?: string
	customThankText?: string
	customeClassname?: string
	contrast?: boolean
}

const ThankYou: React.FC<ThankYouProps> = ({
	name,
	customText = "We have received your submission and will get back to you shortly.",
	customThankText = "Thank You, ",
	customeClassname,
	contrast = false,
}) => {
	const [show, setShow] = useState(false)

	useEffect(() => {
		setShow(true)
	}, [])

	return (
		<div
			className={`${
				show ? styles.wrapper : `${styles.wrapper} ${styles.hide} `
			} ${customeClassname}`}
		>
			<div className={styles.container}>
				<Typography
					contrast={contrast}
					className={styles.title}
					content={
						<>
							{customThankText} {name}!
						</>
					}
					variant={Variant.Title}
				/>
				<Typography
					className={styles.message}
					contrast={contrast}
					content={customText}
					variant={Variant.Paragraph}
				/>
			</div>
		</div>
	)
}

export default ThankYou
